import Mappy from "./components/Mappy/Mappy";

function App() {
  return <Mappy />;
}

export default App;
